module.exports = __webpack_public_path__ + "img/lqBtn2.b12a7d08.png";